import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation(); // detects current route

    useEffect(() => {
        window.scrollTo(0, 0); // scroll to top when route changes
    }, [pathname]);

    return null; // no UI
};

export default ScrollToTop;
